import { doGet } from "../API/apis";

/**
 * Service to handle appointment-related API calls
 */
export class AppointmentService {
  /**
   * Get all appointments for a specific patient
   * @param {string|number} patientId - The patient's ID
   * @returns {Promise<Object>} Response object with status and data
   */
  static async getPatientAppointments(patientId) {
    try {
      const response = await doGet(`/appointments/upcoming-patient-appointments/${patientId}/`);
      console.log(response)
      return response;
    } catch (error) {
      console.error("Error fetching patient appointments:", error);
      return { status: 500, data: null };
    }
  }
}

export default AppointmentService;
